import React from 'react'
import { useTranslation } from 'react-i18next'

import { Content, Layout } from '@/shared/components/ui/layout'

import { PreferencesForm } from './PreferencesForm'

export const PreferencesPage = () => {
	const { t } = useTranslation()

	return (
		<Layout>
			<Content className='p-4'>
				<div className='mx-auto flex w-full max-w-4xl flex-col gap-4'>
					<div className='mt-8 flex flex-col gap-2'>
						<h1 className='text-xl font-bold'>
							{t('conf.title', { defaultValue: 'Preferences' })}
						</h1>
						<p className='text-sm text-muted-foreground'>
							{t('conf.description', {
								defaultValue: 'Manage your preferences and settings.',
							})}
						</p>
					</div>
					<PreferencesForm />
				</div>
			</Content>
		</Layout>
	)
}
